export default "__VITE_ASSET__BShF358F__"